import { getBusinessRatings } from '../../../data/repositories/businessRepository.js';

/**
 * Fetch business ratings and reviews
 * @param {string} businessId - The business ID
 * @param {number} page - Page number (default: 1)
 * @param {number} take - Records per page (default: 10)
 * @returns {Promise<Object>} Ratings data with pagination metadata
 */
export const fetchBusinessRatings = async (businessId, page = 1, take = 10) => {
  if (!businessId) return { data: [], meta: {} };
  const response = await getBusinessRatings(businessId, page, take);
  return {
    data: Array.isArray(response.data) ? response.data : response.data?.data || [],
    meta: response.meta || {}
  };
};
